// extracted by mini-css-extract-plugin
module.exports = {"paper":"Login_paper__kOocm","title":"Login_title__1PdWF","cookieConsent":"Login_cookieConsent__3Y9OH"};